<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">动态管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search" style="margin-top:10px">
            <el-form-item label="类型">
                    <el-select v-model="types" placeholder="请选择">
                        <el-option label="帖子" value="2"></el-option>
                        <el-option label="视频" value="3"></el-option>
                    </el-select>
                </el-form-item>
            <el-form-item label="发布时间">
                <el-date-picker
                    v-model="fwtime"
                    type="daterange"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="发表用户昵称">
                <el-input v-model="nickname" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="发表用户手机号">
                <el-input v-model="phone" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                <el-button size="small" @click="resetting">重置</el-button>

            </el-form-item>
        </el-form>
        <el-table size="small" :data="dataList" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column show-overflow-tooltip prop="title" label="标题" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="readnum" label="播放/阅读" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="integral" label="点赞" >
                    <template slot-scope="scope">{{scope.row.otherData.interestcount}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="integral" label="评论" >
                    <template slot-scope="scope">{{scope.row.otherData.commentnum}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="" label="收藏" >
                    <template slot-scope="scope">{{scope.row.otherData.likecount}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="sharenum" label="分享" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="type" label="类型" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.type === 3">视频</div>
                        <div v-if="scope.row.type === 2">帖子</div>
                        <div v-if="scope.row.type === 1">文字</div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="ishow" label="谁可以看" >
                    <template slot-scope="scope">{{scope.row.type == 0?'私密（谁都不可见）':'公开（谁都可见）'}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="status" label="状态" >
                    <template slot-scope="scope">{{scope.row.status == 0?'草稿':'发布'}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="integral" label="官方账号昵称" >
                    <template slot-scope="scope">{{scope.row.users.nickname}}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="createdate" label="创建时间" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="integral" label="操作人" >
                    <template slot-scope="scope">{{scope.row.adminUsers == null?'':scope.row.adminUsers.name}}</template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="240px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="seecommentClick(scope.row)">查看评论</el-button>
                        <el-button size="mini" type="text" @click="seeClick(scope.row)">查看</el-button>
                        <el-button size="mini" type="text" @click="delClick(scope.row)">删除</el-button>
                        
                    </template>
                </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="推广员名称">
                <el-input size="small" v-model="editForm.name" style="width:230px" auto-complete="off" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号" >
                <el-input size="small" v-model="editForm.phone" style="width:230px" auto-complete="off" placeholder="请输入部门代码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="" :visible.sync="seePostFlag" width="45%" @click="closeDialog">
            <div>
                {{seeForm.category == 1?seeForm.detail:seeForm.title}}
            </div>
            <div>
                <span v-html="seeForm.detail"></span>
            </div>
            <div>
                <img style="width:178px;height:178px;margin:10px 10px 0 0 " v-for="item in seeForm.picList" :key="item" :src="item">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="seePostFlag = false">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="seevideoFlag" width="45%" @click="closeDialog">
            <div>
                {{seeForm.category == 1?seeForm.detail:seeForm.title}}
            </div>
            <VideoPlay
                :videoUrl="seeForm.videourl"
                :videoCover="videoCover"
                width="100%"
                :autoplay="true"
                :controls="true"
                :loop="false"
                :muted="false"
                preload="auto"
                :showPlay="true"
                :playWidth="96"
                zoom="cotain"
            />
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="seevideoFlag = false">关闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="seecommentFlag" width="40%" @click="closeDialog">
            <div style="display:flex">
                <VideoPlay
                    v-if="seecommentForm.type == 3"
                    :videoUrl="seecommentForm.videourl"
                    :videoCover="videoCover"
                    width="300px"
                    :height="200"
                    :autoplay="true"
                    :controls="true"
                    :loop="false"
                    :muted="false"
                    preload="auto"
                    :showPlay="true"
                    :playWidth="96"
                    zoom="cotain"
                />
                <img style="width:300px;height:200px;border-radius:50%" v-if="seecommentForm.type == 2 && seecommentForm.pic != ''" :src="seecommentForm.picList[0]">
                <div>
                    <div v-if="seecommentForm.category == 1">{{seecommentForm.detail}}</div>
                    <span v-if="seecommentForm.category == 2" v-html="seecommentForm.detail"></span>
                </div>
            </div>
            <h3>共{{commentPage.total}}评论</h3>
            <div style="display:flex;" v-for="item of commentdataList" :key="item.id">
                <div>
                    <img style="width:48px;height:48px;border-radius:50%" :src="item.auser.avatar">
                </div>
                <div style="margin:0 15px 0 15px">
                    <div>
                        {{item.auser.nickname}}
                    </div>
                    <div>
                        <span v-if="item.type == 1" style="color:#3D8FFE">回复{{item.nickname}}：</span>
                        {{item.content}}
                        <span>{{item.createdate}} {{item.location}}</span>
                    </div>
                </div>
                <div style="cursor: pointer;" @click="commentdelClick(item.id)">
                    删除
                </div>
            </div>
            <Pagination v-bind:child-msg="commentPage" @callFather="callCommentPage"></Pagination>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="seecommentFlag = false">关闭</el-button>
            </div>
        </el-dialog>
        <el-upload
            v-show="false"
            class="avatar-uploader"
            :data='fileUpload'
            :show-file-list="false"
            :http-request="onUploadHandler"
            >
        </el-upload>
</div>
</template>
<script>
import Pagination from '../../components/Pagination'
import VideoPlay from '../video.vue'
import { articleList  , articleDel , commentList , commentDel} from '../../api/userMG'
export default {
    data(){
        return{
            seecommentForm:{},
            seecommentFlag:false,
            seeForm:{},
            seevideoFlag:false,
            seePostFlag:false,
            nickname:"",
            phone:'',
            types:'',
            fwtime:[],
            area:[],
            radio1:'',
            addTaskForm:{
                mode:1
            },
            addPostFlag:false,
            addvideoFlag:false,
            props: { 
                multiple: true,
                emitPath:false,
             },
            options:[],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
                payChannel:'',
                time:[],
                taskType:''
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            commentPage:{
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            channelsList:[],
            divisionOrder:{},
            rules: {
                integral: [
                { required: true, message: '请输入积分', trigger: 'blur' },
                { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                palyTimes: [
                { required: true, message: '请输入对局数', trigger: 'blur' },
                { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                taskType: [
                { required: true, message: '请选择具体任务', trigger: 'blur' }
                ],
                userSex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
            },
            FileList:[],
            videoFileList:[],
            VideoUrl:'',
            videoCoverFileList:'',
            videoCoverUrl:'',
            dataList:[],
            commentdataList:[]
        }
    },
    components: {
        Pagination,
        VideoPlay
    },
    created(){
        this.articleList()
        // this.loadPayChannelList()
    },
    methods:{
        commentdelClick(id){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                commentDel({id:id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.commentList()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        commentList(){
            commentList({
                id:this.seecommentForm.id,
                page:this.commentPage.currentPage,
                size:this.commentPage.pageSize
            }).then(res=>{
                this.commentdataList = res.data.dataList
                this.commentPage.total = res.data.total
                this.seecommentFlag = true
            })
        },
        seecommentClick(row){
            if(row.pic != '' && row.pic != null){
                let imglist = row.pic.split(',')
                let imgData = []
                for(let item of imglist){
                    imgData.push({
                        url:item
                    })
                }
                row.picList = imgData
            }
            console.log(row)
            this.seecommentForm = row
            this.commentPage = {
                pageSize:10,
                currentPage:1,
            }
            this.commentList()
        },
        
        callCommentPage(parm){
            this.commentPage.page = parm.currentPage
            this.commentPage.pageSize = parm.pageSize
            this.commentList(this.formInline)
        },
        delClick(row){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                articleDel({id:row.id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.articleList()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        seeClick(row){
            if(row.type == 3){
                this.seeForm = row
                this.seevideoFlag = true
            }else {
                row.picList = row.pic == ''?[]:row.pic.split(',')
                this.seeForm = row
                this.seePostFlag = true
            }
        },
        addPostClose(){
            this.FileList = []
            this.content = ''
        },
        
        deleteTask(id){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteTask({id:id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addTaskSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    saveOrUpdateTask({
                        mode:this.addTaskForm.mode,
                        type:this.options[this.addTaskForm.taskType].type,
                        name:this.options[this.addTaskForm.taskType].name,
                        palyTimes:this.addTaskForm.palyTimes,
                        integral:this.addTaskForm.integral,
                        id:this.addTaskForm.id == undefined?'':this.addTaskForm.id
                    }).then(res=>{
                        if(res.success){
                            this.$message.success('创建成功')
                            this.addTaskForm = {
                                mode:1,
                                type:'',
                                integral:'',
                                palyTimes:'',
                            }
                            this.addTaskFlag = false
                            this.getdata()
                        }else {
                            this.$message.error(res.messages)
                        }
                    })
                } else {
                    return false
                }
            })
        },
        
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.formInline.payChannel = ''
            this.formInline.time = []
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.articleList()
        },
        loadPayChannelList(){
            loadPayChannelList({
                
            }).then(res=>{
                this.channelsList = res.channels
            })
        },
        resetting(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.types = ""
            this.fwtime = []
            this.nickname = ''
            this.phone = ''
            this.articleList()
        },
        articleList(){
            articleList({
                page:this.formInline.page,
                size:this.formInline.limit,
                types:this.types == ''?null:[`${this.types}`],
                fwtime:this.fwtime,
                nickname:this.nickname == ''?null:this.nickname,
                phone:this.phone == ''?null:this.phone,
                categorys:[1,2]
            }).then(res=>{
                this.dataList = res.data.dataList
                this.pageparm.total = res.data.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.articleList(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/socialize/management.vue